import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Infinity, Lock } from 'lucide-react';
const CHECKOUT_URL = 'https://jg06af-rb.myshopify.com/checkouts/cn/hWNBgSWxNKncE70n6Yb5rGLa/es-ar?_r=AQAByHkJ8jcZdIvEe0H8ZdDRIkXMpmN5rxgoS347IycFAIY&preview_theme_id=133867339873';
export function PricingSection() {
  return <section className="bg-offwhite py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-122">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full opacity-5 pointer-events-none" data-id="element-123">
        <div className="absolute top-20 left-10 w-64 h-64 bg-gold rounded-full blur-3xl" data-id="element-124"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-leather-warm rounded-full blur-3xl" data-id="element-125"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden flex flex-col lg:flex-row" data-id="element-127">
          {/* Left side: Mockup */}
          <div className="lg:w-1/2 bg-cream p-8 lg:p-12 flex flex-col items-center justify-center relative" data-id="element-128">
            <div className="absolute top-6 left-6 bg-red-600 text-white font-bold px-4 py-2 rounded-full transform -rotate-12 shadow-lg z-20" data-id="element-129">
              -70% DTO.
            </div>
            <motion.div animate={{
            y: [0, -5, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full max-w-md rounded-2xl overflow-hidden shadow-2xl border-4 border-white z-10" data-id="element-130">
              <img src="https://cdn.magicpatterns.com/uploads/aLVaccxKKwZEQE6HdzGmdB/HERO.webp" alt="Biblioteca de Patrones" className="w-full h-auto" data-id="element-131" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-132">
                <p className="text-white font-heading font-bold text-2xl" data-id="element-133">
                  La Biblioteca Definitiva
                </p>
              </div>
            </motion.div>
          </div>

          {/* Right side: Pricing & CTA */}
          <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center" data-id="element-134">
            <h3 className="font-heading text-3xl sm:text-4xl font-bold text-leather-dark mb-6" data-id="element-135">
              Acceso Completo a la Biblioteca + 6 Bonos
            </h3>

            <div className="mb-8" data-id="element-136">
              <p className="text-gray-500 text-lg mb-1" data-id="element-137">
                Precio Normal: <span className="line-through" data-id="element-138">$74.940</span>
              </p>
              <div className="flex items-baseline gap-2" data-id="element-139">
                <span className="text-5xl sm:text-6xl font-black text-leather-dark tracking-tight" data-id="element-140">
                  $19.990
                </span>
                <span className="text-gray-600 font-medium" data-id="element-141">pago único</span>
              </div>
            </div>

            <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" animate={{
            boxShadow: ['0px 0px 0px rgba(201,168,76,0)', '0px 0px 20px rgba(201,168,76,0.6)', '0px 0px 0px rgba(201,168,76,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="w-full flex items-center justify-center bg-gold hover:bg-gold-hover text-darktext font-bold text-xl px-8 py-5 rounded-xl shadow-[0_8px_30px_rgb(201,168,76,0.3)] transform transition hover:-translate-y-1 mb-6" data-id="element-142">
              QUIERO MI BIBLIOTECA DE PATRONES »
            </motion.a>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-600 mb-8" data-id="element-143">
              <Lock className="w-4 h-4 text-green-600" data-id="element-144" />
              <span data-id="element-145">Pago 100% Seguro y Encriptado</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border-t border-gray-100 pt-8" data-id="element-146">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-147">
                <ShieldCheck className="w-8 h-8 text-leather-warm" data-id="element-148" />
                <span className="text-sm font-medium text-gray-800" data-id="element-149">
                  Pago Seguro
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-150">
                <Download className="w-8 h-8 text-leather-warm" data-id="element-151" />
                <span className="text-sm font-medium text-gray-800" data-id="element-152">
                  Descarga Inmediata
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-153">
                <Infinity className="w-8 h-8 text-leather-warm" data-id="element-154" />
                <span className="text-sm font-medium text-gray-800" data-id="element-155">
                  Acceso de por Vida
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}